import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";
import toast from "react-hot-toast";

import { requestUpdateFeedInsert } from "./updateFeedInsert.request";

const useUpdateFeedInsert = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  const refetchFeedInserts = useRefetchQuery(["feed-inserts"]);

  return useMutation({
    mutationFn: requestUpdateFeedInsert,
    ...options,
    onSuccess: (data, variables, context) => {
      void refetchFeedInserts();
      toast.success("Feed insert updated successfully");
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useUpdateFeedInsert;
